<script>
import { BBadge, BModal } from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable.vue";
import {ProductApi} from "@core/api";
import dateRenderer from "@core/mixins/date-renderer";
import {SubmissionStatus} from "@/libs/product";
import {FilterInput, VueSelectFilter} from "@core/components/common/filter";
import StatusBadge from "@/views/product/scip-notification/StatusBadge.vue";

export default {
    mixins: [dateRenderer],
    components: {FilterInput, HamletTable, BBadge, VueSelectFilter, StatusBadge},
    data() {
        return {
            isSearchActive: false,
            errorSubmission: null,
            numberOfItemsToShowFilter: 10,
            statusOptions: SubmissionStatus.toArray().map(status => {
                return {
                    id: status,
                    title: this.$t(SubmissionStatus.getTranslationKey(status))
                }
            }),
            fields: [
                {
                    key: 'createdAt',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-sent-at'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-sent-at'),
                },
                {
                    key: 'status',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-status'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-status'),
                },
                {
                    key: 'pk',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-pk'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-pk'),
                },
                {
                    key: 'pn',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-pn'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-pn'),
                },
                {
                    key: 'productName',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-product-name'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-product-name'),
                },
                {
                    key: 'supplier',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-supplier'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-supplier'),
                },
                {
                    key: 'lastNotificationDate',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-last-notification-date'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-last-notification-date'),
                },
                {
                    key: 'scipNumber',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-scip-number'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-scip-number'),
                },
                {
                    key: 'submissionNumber',
                    label: this.$t('Page(SubmissionOverview):Component(Grid):field-submission-number'),
                    title: this.$t('Page(SubmissionOverview):Component(Grid):hover-field-submission-number'),
                },
            ],
        };
    },
    methods: {
        onRowClick(submission) {
            this.$router.push({
                name: 'submission-card',
                params: {id: submission.id}
            })
        },
        fetch(config, cb) {
            ProductApi
                .getSubmissions(config.filters, {}, config.page, config.perPage)
                .then(r => {
                    if (false === this.isSearchActive && r.data.totalItems > this.numberOfItemsToShowFilter) {
                        this.isSearchActive = true;
                    }
                    cb(r.data.totalItems, r.data.items);
                });
        },

        filter(field, value) {
            this.$refs.hamletTable.filter(field, value);
        },
        filterStatus(statuses) {
            this.$refs.hamletTable.filter('status', statuses.map(s => s.id))
        },

        onStatusBadgeClick(submission) {
            switch (submission.status) {
                case SubmissionStatus.ERROR:
                case SubmissionStatus.ECHA_SERVER_ERROR:
                case SubmissionStatus.CHECK_STATUS_ATTEMPTS_EXCEEDED:
                case SubmissionStatus.FAILED:
                    this.errorSubmission = submission;
                    this.$refs.errors.show();
                break;
            }
        },
        renderLastNotificationDate(submission) {
            if (submission.lastNotificationDate) {
                return this.renderDate(submission.lastNotificationDate) + ' ' + this.renderTime(submission.lastNotificationDate);
            }
            return '';
        },
        onProductNameClick(item) {
            this.$router.push({
                name: 'product-card',
                params: {id: item.product.id}
            })
        }
    }
}
</script>

<template>
    <div>
        <b-modal
            ref="errors"
            centered
            title="Errors"
            ok-only
            :ok-title="$t('Component(Button):close')"
        >
            <div v-if="errorSubmission">
                <p>{{ errorSubmission.errorMessage }}</p>

                <ul>
                    <li v-for="error in errorSubmission.validationErrorMessages">{{ error }}</li>
                </ul>
            </div>
        </b-modal>

        <HamletTable
            ref="hamletTable"
            :columns="fields"
            :fetch="fetch"
            :search="isSearchActive"
            @onRowClick="onRowClick"
        >
            <template #header-label>
                {{ $t('Page(SubmissionOverview):Component(Label):page-label') }}
            </template>

            <template #cell-createdAt="data">
                {{ renderDate(data.item.createdAt) }} {{ renderTime(data.item.createdAt) }}
            </template>

            <template #filter-cell-pn>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('pn', v)"
                />
            </template>

            <template #filter-cell-scipNumber>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('scipNumber', v)"
                />
            </template>

            <template #filter-cell-submissionNumber>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('submissionNumber', v)"
                />
            </template>

            <template #filter-cell-pk>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('pk', v)"
                />
            </template>

            <template #filter-cell-productName>
                <FilterInput
                    style="min-width: 120px;"
                    @search="(v) => filter('productName', v)"
                />
            </template>


            <template #filter-cell-status>
                <VueSelectFilter
                    style="min-width: 120px;"
                    :options="statusOptions"
                    @filter="filterStatus"
                />
            </template>

            <template #cell-status="data">
                <div @click.stop.prevent="onStatusBadgeClick(data.item)">
                    <StatusBadge :submission="data.item"/>
                </div>
            </template>

            <template #cell-pn="data">
                {{ data.item.pn.value }}
            </template>

            <template #cell-pk="data">
                {{ data.item.pk.value }}
            </template>

            <template #cell-productName="data">
                <div
                    class="text-decoration-underline"
                    @click.stop.prevent="onProductNameClick(data.item)"
                >
                    {{ data.item.product.names.length > 0 ? data.item.product.names[0].value : '' }}
                </div>
            </template>

            <template #cell-supplier="data">
                {{ data.item.supplier ? data.item.supplier.title : '' }}
            </template>

            <template #cell-lastNotificationDate="data">
                {{ renderLastNotificationDate(data.item) }}
            </template>

            <template #cell-scipNumber="data">
                {{ data.item.scipNumber }}
            </template>

            <template #cell-submissionNumber="data">
                {{ data.item.number }}
            </template>
        </HamletTable>
    </div>
</template>

<style scoped lang="scss">

</style>
